import { render, staticRenderFns } from "./ParkingDetails.vue?vue&type=template&id=09bde4fc&scoped=true&"
import script from "./ParkingDetails.vue?vue&type=script&lang=js&"
export * from "./ParkingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bde4fc",
  null
  
)

export default component.exports